import { useCallback } from "react";
import {
  APP_SETTINGS,
  ARCGIS_SERVICES_ROOT_URL,
  DEFAULT_COMPLIANCE_YEAR,
} from "../settings";
import useEsri from "../hooks/useEsri";
import useFieldState from "../hooks/useFieldState";

const usePollutantMetric = () => {
  const { geoProcessor } = useEsri();
  const [fieldDataState] = useFieldState();
  const { pollutant_metric_list } = fieldDataState;

  const fetchPollutionMetrics = useCallback(async () => {
    const { GP } = APP_SETTINGS.GIS_SERVER;
    const gpServiceUrls = await geoProcessor(GP.LIST_OF_SERVICE_URL);
    const params = {
      year: DEFAULT_COMPLIANCE_YEAR,
    };
    const pollutantMetricResponse = await gpServiceUrls.execute(params);
    return pollutantMetricResponse.results[0]["value"];
  }, [geoProcessor]);

  const getPollutantMetricItemById = useCallback(
    (id) => {
      if (!id) return { name: "" };
      const getZone = pollutant_metric_list["zone"].filter(
        (item) => item.id === id
      );
      if (getZone.length) {
        return getZone[0];
      }
      const getLa = pollutant_metric_list["la"].filter(
        (item) => item.id === id
      );
      if (getLa.length) {
        return getLa[0];
      }
    },
    [pollutant_metric_list]
  );

  const getPollutantMetricUrl = useCallback((servicesName) => {
    if (!servicesName) return;
    return `${ARCGIS_SERVICES_ROOT_URL}Hosted/${servicesName}/FeatureServer/0`;
  }, []);

  return {
    fetchPollutionMetrics,
    getPollutantMetricItemById,
    getPollutantMetricUrl,
  };
};

export default usePollutantMetric;
